<template>
  <div class="pop_enter popup_wrap" id="popenter" style="display:block;">
    <div class="popup_in">
      <div class="popup login_box">
        <div class="corner-top"></div>
        <div class="popup_close stay_close close-animate">
          <a href="javascript:void(0);" @click.prevent="close">
            <CLOSE/>
          </a>
        </div>
        <div class="pp_enter_top">
          <div class="title_has_svg">
            <LOGO/>
            <h2 class="title center" v-if="title == 'favs'">כדי להיכנס לעמוד המועדפים יש להתחבר או להצטרף</h2>
            <h2 class="title center" v-if="title == 'history'">כדי לשחזר הזמנה קודמת יש להתחבר או להצטרף</h2>
            <h2 class="title center" v-if="title == 'login'">כיף שחזרת!</h2>
            <h2 class="title center" v-if="title == 'reg'" style="margin-bottom:0;">כיף לראות אותך!</h2>
            <div class=" text center" v-if="title == 'reg'" style="margin-bottom:25px;">תהליך הצטרפות מהיר, קליל וייקח לך פחות מדקה</div>
          </div>
          <div class="prod_details_tabs login_tabs">
            <div class="inline clearfix">
              <div class="right prod_details_tab login_tab" v-bind:class="{ active: title == 'reg' }">
                <a href="javascript:void(0);" @click="changeTab('reg')">פעם ראשונה?</a>
              </div>
              <div class="right prod_details_tab login_tab" v-bind:class="{ active: title != 'reg' }">
                <a href="javascript:void(0);" @click="changeTab('login')">כניסה לחשבון</a>
              </div>
            </div>
          </div>
        </div>
        <div class="pp_enter_bottom">
          <div class="login_inner pp_enter-login" v-if="title != 'reg'">
            <login-form @componentEmit="componentEmit"></login-form>
          </div>
          <div class="login_inner pp_enter-register" v-if="title == 'reg'">
            <register-form></register-form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import LoginForm from "../Forms/LoginForm";
  import RegisterForm from "../Forms/RegisterForm";
  import LOGO from "../../assets/img/carmella.svg";
  import CLOSE from "../../assets/img/close.svg";
  import FACEBOOK from "../../assets/img/soc_face.svg";
  import GOOGLE from "../../assets/img/soc_g.svg";
  import axios from "axios";
  export default {
    props: ["state"],
    data() {
      return {
        title: this.state,
        homeUrl: wpData.home_url,
        error: "",
        isHistory: false
      };
    },
    mounted() {
      this.$root.$on("go_to_history", () => {
      });
    },
    methods: {
      changeTab(tab) {
        this.title = tab;
      },
      close() {
        this.$modal.hide("login-modal");
      },
      submitRegister(el) {},
      componentEmit() {
        this.changeTab('reg');
      }
    },
    components: { LOGO, CLOSE, FACEBOOK, GOOGLE, LoginForm, RegisterForm }
  };
</script>

<style lang="sass" scoped>
  .prod_details_tab.active a
    color: #1e824c !important
    position: relative
    &:after
      content: ''
      position: absolute
      bottom: 0
      left: 50%
      transform: translateX(-2.5px)
      width: 0
      height: 0 
      border-left: 5px solid transparent
      border-right: 5px solid transparent
      border-bottom: 5px solid #1e824c
  .prod_details_tab a
    color: #000 !important

</style>
